import {parse} from 'marked';
import {GenReleaseNote} from '../../generated/serverModels/GenReleaseNote';

export class ReleaseNote extends GenReleaseNote {

  constructor(note?: ReleaseNote) {
    super(note);
    if (note) {
      this.notes = parse(note.notes, {async: false});
    }
  }
}
